import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function ApplicationBasicInfoComponent ({domainDetails,networks,onFormChange,channels,tenants,selectedApplicationRegistreation}: any) {
  const libraryData = useSelector(selectListItems)
  const typeData: any = libraryData.result.Type;
  const channelData: any = libraryData.result.ChannelList

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
<InputContainer

    label="Name"
    name="Name"
    onValueChange={(event: any) => {
      onFormChange({
        value: event.target.value,
        field: 'Name'
      });
    }}
    type="text"
    value={selectedApplicationRegistreation?.Name}
/>
<InputContainer
                 label="Domain Name"
                 labelField="Name"
                 list={domainDetails}
                 onValueChange={(event: any, newValue: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'DomainId'
                  });
                 }}
                 optionName="Choose Domain"
                 type="select"
                 value={selectedApplicationRegistreation?.DomainId}
                 valueField="Id"
             />
<InputContainer

    label="Secret Key"
    name="SecretKey"
    onValueChange={(event: any) => {
      onFormChange({
        value: event.target.value,
        field: 'SecretKey'
      });
    }}
    type="text"
    value={selectedApplicationRegistreation?.SecretKey}
/>
<InputContainer

    label="Code"
    name="Code"
    onValueChange={(event: any) => {
      onFormChange({
        value: event.target.value,
        field: 'Code'
      });
    }}
    type="text"
    value={selectedApplicationRegistreation?.Code}
/>
<InputContainer

    label="Limited To Tenants"
    name="LimitedToTenants"
    onValueChange={(event: any) => {
      onFormChange({
        value: event,
        field: 'LimitedToTenants'
      });
    }}
    type="checkbox"
    value={selectedApplicationRegistreation?.LimitedToTenants}
/>
      {selectedApplicationRegistreation?.LimitedToTenants === true &&
     <InputContainer
     label="Tenant Name" 
                      labelField="CompanyName"
                      list={tenants}
                      onValueChange={( newValue: any) => {
                        const valueData: any = newValue.map((option: any) => option?.value)
                        onFormChange({
                          value: valueData,
                          field: 'LimitedToTenantIds'
                        });
                      }}
                      type="multiselect"
                      valueField="Id"
                      value={selectedApplicationRegistreation?.LimitedToTenantMappings?.LimitedToTenantIds}
  />}

<InputContainer
     label="Channel Name" 
                      labelField="Name"
                      list={channels}
                      onValueChange={( newValue: any) => {
                        const valueData: any = newValue.map((option: any) => option?.value)
                        onFormChange({
                          value: valueData,
                          field: 'ChannelNames'
                        });
                      }}
                      type="multiselect"
                      valueField="Name"
                      value={selectedApplicationRegistreation?.ChannelMappings?.ChannelNames}
  />

{/* <InputContainer
     label="AccountType Name" 
                      labelField="Name"
                      list={networks}
                      onValueChange={( newValue: any) => {
                        const valueData: any = newValue.map((option: any) => option?.value)
                        onFormChange({
                          value: valueData,
                          field: 'AccountTypes'
                        });
                      }}
                      type="multiselect"
                      valueField="Name"
                      value={selectedApplicationRegistreation?.AccountTypeMappings?.AccountTypes}
  /> */}
  <InputContainer
     label="Network Name" 
                      labelField="Name"
                      list={networks}
                      onValueChange={( newValue: any) => {
                        const valueData: any = newValue.map((option: any) => option?.value)
                        onFormChange({
                          value: valueData,
                          field: 'Networks'
                        });
                      }}
                      type="multiselect"
                      valueField="Id"
                      value={selectedApplicationRegistreation?.NetworkMappings?.Networks}
  />
  <div className='col-span-full'>
 <InputContainer

     label="Short Description"
     name="ShortDescription"
     onValueChange={(event: any) => {
       onFormChange({
         value: event,
         field: 'ShortDescription'
       });
     }}
       type="rte"
     value={selectedApplicationRegistreation?.ShortDescription}
 /></div>
   <div className='col-span-full'>
 <InputContainer

     label="Long Description"
     name="LongDescription"
     onValueChange={(event: any) => {
       onFormChange({
         value: event,
         field: 'LongDescription'
       });
     }}
      type="rte"
     value={selectedApplicationRegistreation?.LongDescription}
 /></div>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}